import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-teal-400">FenetrePro</h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Votre expert en réparation de fenêtres à Toulouse et dans toute la Haute-Garonne. Service rapide et professionnel.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-all cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-teal-400">Liens Rapides</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  À propos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Nos services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Réalisations
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Témoignages
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-teal-400">Nos Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">Réparation fenêtre PVC</li>
              <li className="text-gray-300">Réparation fenêtre bois</li>
              <li className="text-gray-300">Baie vitrée</li>
              <li className="text-gray-300">Volet roulant</li>
              <li className="text-gray-300">Double vitrage</li>
              <li className="text-gray-300">Dépannage urgent 24h/24</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-teal-400">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-teal-400 mr-3 mt-1"></i>
                <div>
                  <a href="tel:0554542545" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                    05 54 54 25 45
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-whatsapp-line text-teal-400 mr-3 mt-1"></i>
                <div>
                  <a href="https://wa.me/33745883392" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                    07 45 88 33 92
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-teal-400 mr-3 mt-1"></i>
                <div className="text-gray-300">
                  Toulouse et toute la Haute-Garonne
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-teal-400 mr-3 mt-1"></i>
                <div className="text-gray-300">
                  Lun - Sam : 8h - 19h<br />
                  <span className="text-sm">Urgences 24h/24</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Informations légales */}
          <div>
            <h4 className="text-lg font-bold mb-6">Informations légales</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/mentions-legales" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                  Mentions Légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                  Politique de Confidentialité
                </Link>
              </li>
              <li>
                <Link to="/politique-cookies" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                  Politique de Cookies
                </Link>
              </li>
              <li>
                <Link to="/assurance-certifications" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                  Assurances & Certifications
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 FenetrePro Toulouse. Tous droits réservés.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <button onClick={() => scrollToSection('mentions-legales')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Mentions Légales
              </button>
              <button onClick={() => scrollToSection('politique-confidentialite')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Politique de Confidentialité
              </button>
              <button onClick={() => scrollToSection('politique-cookies')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Politique de Cookies
              </button>
              <button onClick={() => scrollToSection('assurance-certifications')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Assurance &amp; Certifications
              </button>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
